import Axios from "axios";
import { BASE_URL } from "../config/endpoints/general";
import { getToken, removeToken } from "../../plugins/handlers";

let token = getToken();

const instance = Axios.create({
  baseURL: BASE_URL,
  timeout: 100000000,
  headers: {
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  },
});

instance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // if (error.response && error.response.status === 401) {
    //   removeToken();
    //   return window.location.href = "/login";
    // }
    return Promise.reject(error);
  }
);

async function getCall(url, params) {
  return await instance.get(url, { params: params });
}

async function postCall(url, params) {
  return await instance.post(url, params);
}

async function putCall(url, params) {
  return instance.put(url, params);
}

async function deleteCall(url, params) {
  return instance.delete(url, params);
}

async function patchCall(url, params) {
  return instance.patch(url, params);
}

export { getCall, postCall, putCall, deleteCall, patchCall };
